import "babel-polyfill";
import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";
import "./libs/infiniteslidev2";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {animationOnScroll} from "./modules/animationOnScroll";
import {parallax} from "./modules/parallax";
import {popups} from "./modules/popups";
import {customSelect} from "./modules/customSelect";
import {heroSlider} from "./modules/heroSlider";
import {animatedSlider} from "./modules/animatedSlider";
import {productsSlider} from "./modules/productsSlider";
import {cookies} from "./modules/cookies";
import {accordion} from "./modules/accordion";
import {anchorLinks} from "./modules/anchorLinks";
import {tableWrap} from "./modules/tableWrap";
import {leadershipSlider} from "./modules/leadershipSlider";
import {video} from "./modules/video";
import {timelineSlider} from "./modules/timelineSlider";
import {showMoreIngredients} from "./modules/showMoreIngredients";
import {hash} from "./modules/hash";
import {googleMap} from "./modules/googleMap";
import {locationsScroll} from "./modules/locationsScroll";
import {loadMoreProducts} from "./modules/loadMoreProducts";
import {loadMoreIngredients} from "./modules/loadMoreIngredients";
import {contactsForm} from "./modules/contactsForm";
import {contactsSearch} from "./modules/contactsSearch";
import {locationsSearch} from "./modules/locationsSearch";

binder({
    bounds: {
        html: [constants, fullHeightPage, anchorLinks, hash],
        ".header": [stickyHeader, mobileNav],
        ".has-animation": animationOnScroll,
        ".has-parallax": parallax,
        ".popups": popups,
        "select": customSelect,
        ".hero-slider-section": heroSlider,
        ".animated-slider": animatedSlider,
        ".products-slider": productsSlider,
        ".cookies": cookies,
        ".accordion": accordion,
        "table": tableWrap,
        ".leadership-slider": leadershipSlider,
        ".video-holder": video,
        ".timeline-slider": timelineSlider,
        ".ingredients-section": showMoreIngredients,
        ".google-map": googleMap,
        ".locations-list": locationsScroll,
        ".products-section": loadMoreProducts,
        ".products-intro": loadMoreIngredients,
        ".location-search": locationsSearch,
        ".contacts-section": contactsForm,
        ".contacts-info .search-form": contactsSearch
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js